export default {
  sendMessage( state, msg ) {
    state.pending.push( msg );
  },
  messageSended( state, msg ) {
    var index = state.pending.indexOf( msg );
    if ( index !== -1 ) state.pending.splice( index, 1 );
  }
}
